import React from "react"
import accessibleSvg from "src/utils/accessibleSvg"

export default accessibleSvg(({ children, ...props }) => (
  <svg
    fill="currentColor"
    viewBox="0 0 100 100"
    width="100"
    height="100"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    {children}
    <path
      id="Chat"
      fillRule="evenodd"
      d="M50,100c49.614,0,50-22.386,50-50S99.614,0,50,0,0,22.386,0,50,0.386,100,50,100ZM72.227,70.227l3.049,2.033A1.628,1.628,0,0,1,76,73.614v0.759A1.627,1.627,0,0,1,74.373,76H58.667c-10.529,0-17.333-6.8-17.333-17.333s6.8-17.333,17.333-17.333S76,48.138,76,58.667A17.823,17.823,0,0,1,72.227,70.227ZM58.667,47.833c-6.986,0-10.833,3.847-10.833,10.834S51.681,69.5,58.667,69.5,69.5,65.653,69.5,58.667,65.653,47.833,58.667,47.833ZM41.333,30.5C34.347,30.5,30.5,34.347,30.5,41.334c0,4.945,1.935,8.31,5.541,9.857A1.6,1.6,0,0,1,37,52.666v4.375a1.624,1.624,0,0,1-1.625,1.625H25.627A1.627,1.627,0,0,1,24,57.04V56.281a1.628,1.628,0,0,1,.724-1.355l3.048-2.033A17.827,17.827,0,0,1,24,41.334C24,30.8,30.8,24,41.333,24c8.468,0,14.512,4.41,16.558,11.611A1.091,1.091,0,0,1,56.845,37H53.016a2.187,2.187,0,0,1-1.969-1.278C49.441,32.321,46.131,30.5,41.333,30.5Z"
    />
  </svg>
))
